<template>
  <div class="hotels-list">
    <app-spinner v-if="!is_loaded"/>
    <template v-else>
      <h1 class="title">Dashboard</h1>
      <template v-if="table_missing_email.items.length">
        <app-cells><h2 class="title">Hotel missing reservations email</h2></app-cells>
        <v-client-table
          :data="table_missing_email.items"
          :columns="table_missing_email.columns"
          :options="table_missing_email.options"
          class="table-default"
        >
          <template #h__name>
            <div class="table-default__left">Name</div>
          </template>
          <template #h__region>
            <div class="table-default__left">Region</div>
          </template>
          <template #h__area>
            <div class="table-default__left">Area</div>
          </template>
          <template #name="{ row }">
            <div class="table-default__left">
              <router-link :to="{ name: 'hotels-database-general', params: { id: row.id } }"
                           class="table-default__link-border">
                {{ row.name }}
              </router-link>
            </div>
          </template>
          <template #star="{ row }">
            <star-rating
              :rating="row.rating"
              :read-only="true"
              :star-size="22"
              :show-rating="false"
              :inline="true"
              :rounded-corners="true"
              :increment="0.5"
              active-color="#eb9514"
              inactive-color="#d1d1d1"
            ></star-rating>
          </template>
          <template #external="{ row }">
            <app-cells position="center" :indent="false">
              <div class="table-default__rating">
                <template v-if="row.booking">
                  <a :href="row.booking" target="_blank">
                    <img src="@/assets/img/booking-active-icon.svg" alt=""> {{ row.booking_rating }}
                  </a>
                </template>
                <img v-else src="@/assets/img/booking-not-active-icon.svg" alt="">
              </div>
              <div class="table-default__rating">
                <template v-if="row.tripadvisor">
                  <a :href="row.tripadvisor" target="_blank">
                    <img src="@/assets/img/tripadvisor-active-icon.svg" alt=""> {{ row.tripadvisor_rating }}
                  </a>
                </template>
                <img v-else src="@/assets/img/tripadvisor-not-active-icon.svg" alt="">
              </div>
            </app-cells>
          </template>
          <template #region="{ row }">
            <div class="table-default__left">{{ row.region?.name || '-' }}</div>
          </template>
          <template #area="{ row }">
            <div class="table-default__left">{{ row.area?.name || '-' }}</div>
          </template>
        </v-client-table>
        <app-cells position="between">
          <div>
            <paginate
              :clickHandler="onClickMissingEmailPagination"
              v-if="pagination_missing_email.pages > 1"
              v-model="pagination_missing_email.page"
              :page-count="pagination_missing_email.pages"
              :prev-text="'<'"
              :next-text="'>'"
              :container-class="'pagination'"
              :page-class="'pagination__item'"
              :page-link-class="'pagination__link'"
              :prev-class="'pagination__item pagination__item--prev'"
              :next-class="'pagination__item pagination__item--next'"
              :next-link-class="'pagination__link pagination__link--next'"
              :prev-link-class="'pagination__link pagination__link--prev'"
            />
          </div>
          <app-table-records
            :all="pagination_missing_email.count"
            :count="table_missing_email.items.length"
            :page="pagination_missing_email.page"
            :limit="5"
          />
        </app-cells>
      </template>
      <app-cells><h2 class="title">Hotel missing supplier</h2></app-cells>
      <v-client-table
        :data="table_missing_supplier.items"
        :columns="table_missing_supplier.columns"
        :options="table_missing_supplier.options"
        class="table-default"
      >
        <template #h__name>
          <div class="table-default__left">Name</div>
        </template>
        <template #h__region>
          <div class="table-default__left">Region</div>
        </template>
        <template #h__area>
          <div class="table-default__left">Area</div>
        </template>
        <template #name="{ row }">
          <div class="table-default__left">
            <router-link :to="{ name: 'hotels-database-general', params: { id: row.id } }"
                         class="table-default__link-border">
              {{ row.name }}
            </router-link>
          </div>
        </template>
        <template #star="{ row }">
          <star-rating
            :rating="row.rating"
            :read-only="true"
            :star-size="22"
            :show-rating="false"
            :inline="true"
            :rounded-corners="true"
            :increment="0.5"
            active-color="#eb9514"
            inactive-color="#d1d1d1"
          ></star-rating>
        </template>
        <template #external="{ row }">
          <app-cells position="center" :indent="false">
            <div class="table-default__rating">
              <template v-if="row.booking">
                <a :href="row.booking" target="_blank">
                  <img src="@/assets/img/booking-active-icon.svg" alt=""> {{ row.booking_rating }}
                </a>
              </template>
              <img v-else src="@/assets/img/booking-not-active-icon.svg" alt="">
            </div>
            <div class="table-default__rating">
              <template v-if="row.tripadvisor">
                <a :href="row.tripadvisor" target="_blank">
                  <img src="@/assets/img/tripadvisor-active-icon.svg" alt=""> {{ row.tripadvisor_rating }}
                </a>
              </template>
              <img v-else src="@/assets/img/tripadvisor-not-active-icon.svg" alt="">
            </div>
          </app-cells>
        </template>
        <template #region="{ row }">
          <div class="table-default__left">{{ row.region?.name || '-' }}</div>
        </template>
        <template #area="{ row }">
          <div class="table-default__left">{{ row.area?.name || '-' }}</div>
        </template>
      </v-client-table>
      <app-cells position="between">
        <div>
          <paginate
            :clickHandler="onClickMissingSupplierPagination"
            v-if="pagination_missing_supplier.pages > 1"
            v-model="pagination_missing_supplier.page"
            :page-count="pagination_missing_supplier.pages"
            :prev-text="'<'"
            :next-text="'>'"
            :container-class="'pagination'"
            :page-class="'pagination__item'"
            :page-link-class="'pagination__link'"
            :prev-class="'pagination__item pagination__item--prev'"
            :next-class="'pagination__item pagination__item--next'"
            :next-link-class="'pagination__link pagination__link--next'"
            :prev-link-class="'pagination__link pagination__link--prev'"
          />
        </div>
        <app-table-records
          :all="pagination_missing_supplier.count"
          :count="table_missing_supplier.items.length"
          :page="pagination_missing_supplier.page"
          :limit="10"
        />
      </app-cells>
      <app-cells><h2 class="title">Missing invoice</h2></app-cells>
      <template v-if="reservations_missing_invoice.length">
        <div v-for="(reservation, index) in reservations_missing_invoice" :key="`missing_invoice_${index}`">
          <AppAccHotel :reservation="reservation" :order-number="index + 1"/>
        </div>
        <app-cells position="between">
          <div>
            <paginate
              :clickHandler="onClickMissingInvoicePagination"
              v-if="pagination_missing_invoice.pages > 1"
              v-model="pagination_missing_invoice.page"
              :page-count="pagination_missing_invoice.pages"
              :prev-text="'<'"
              :next-text="'>'"
              :container-class="'pagination'"
              :page-class="'pagination__item'"
              :page-link-class="'pagination__link'"
              :prev-class="'pagination__item pagination__item--prev'"
              :next-class="'pagination__item pagination__item--next'"
              :next-link-class="'pagination__link pagination__link--next'"
              :prev-link-class="'pagination__link pagination__link--prev'"
            />
          </div>
          <app-table-records :all="pagination_missing_invoice.count" :count="reservations_missing_invoice.length"
                             :page="pagination_missing_invoice.page" :limit="5"/>
        </app-cells>
      </template>
      <template v-if="reservations_meal_missing_invoice.length">
        <app-cells-grid :columns="1" gap="10px" :margin-bottom="30">
          <AppAccMeal
            v-for="(meal, index) in reservations_meal_missing_invoice"
            :key="`missing_invoice_${meal.id}`"
            :reservation="meal"
            :order-number="index + 1"
          />
        </app-cells-grid>
        <app-cells :position="pagination_meals_missing_invoice.pages > 1 ? 'between' : 'end'">
          <paginate
            :clickHandler="onClickMealsMissingInvoicePagination"
            v-if="pagination_meals_missing_invoice.pages > 1"
            v-model="pagination_meals_missing_invoice.page"
            :page-count="pagination_meals_missing_invoice.pages"
            :prev-text="'<'"
            :next-text="'>'"
            :container-class="'pagination'"
            :page-class="'pagination__item'"
            :page-link-class="'pagination__link'"
            :prev-class="'pagination__item pagination__item--prev'"
            :next-class="'pagination__item pagination__item--next'"
            :next-link-class="'pagination__link pagination__link--next'"
            :prev-link-class="'pagination__link pagination__link--prev'"
          />
          <app-table-records :all="pagination_meals_missing_invoice.count"
                             :count="reservations_meal_missing_invoice.length"
                             :page="pagination_meals_missing_invoice.page"
                             :limit="5"/>
        </app-cells>
      </template>
      <div v-else class="no-results no-results--margin">
        <img src="@/assets/img/schedule-plug-icon.svg" alt="">
        <div class="no-results__title">No Results</div>
        <div class="no-results__text">There’s no bookings yet</div>
      </div>
      <app-cells><h2 class="title">Missing voucher</h2></app-cells>
      <template v-if="reservations_missing_voucher.length">
        <div v-for="(reservation, index) in reservations_missing_voucher" :key="`missing_voucher_${index}`">
          <AppAccHotel :reservation="reservation" :order-number="index + 1"/>
        </div>
        <app-cells position="between">
          <div>
            <paginate
              :clickHandler="onClickMissingVoucherPagination"
              v-if="pagination_missing_voucher.pages > 1"
              v-model="pagination_missing_voucher.page"
              :page-count="pagination_missing_voucher.pages"
              :prev-text="'<'"
              :next-text="'>'"
              :container-class="'pagination'"
              :page-class="'pagination__item'"
              :page-link-class="'pagination__link'"
              :prev-class="'pagination__item pagination__item--prev'"
              :next-class="'pagination__item pagination__item--next'"
              :next-link-class="'pagination__link pagination__link--next'"
              :prev-link-class="'pagination__link pagination__link--prev'"
            />
          </div>
          <app-table-records :all="pagination_missing_voucher.count" :count="reservations_missing_voucher.length"
                             :page="pagination_missing_voucher.page" :limit="5"/>
        </app-cells>
      </template>
      <div v-else class="no-results no-results--margin">
        <img src="@/assets/img/schedule-plug-icon.svg" alt="">
        <div class="no-results__title">No Results</div>
        <div class="no-results__text">There’s no bookings yet</div>
      </div>
      <app-cells>
        <h2 class="title">Abnormal price</h2>
        <app-button
          @click.native="onExportAbnormalPrice"
          theme="export"
          :class="{'btn--export--loading': export_abnormal_loading }"
        >
          Export
        </app-button>
      </app-cells>
      <template v-if="reservations_abnormal_price.length">
        <div v-for="(reservation, index) in reservations_abnormal_price" :key="`abnormal_price_${index}`">
          <AppAccHotel :reservation="reservation" :order-number="index + 1" />
        </div>
        <app-cells position="between">
          <div>
            <paginate
              :clickHandler="onClickAbnormalPricePagination"
              v-if="pagination_abnormal_price.pages > 1"
              v-model="pagination_abnormal_price.page"
              :page-count="pagination_abnormal_price.pages"
              :prev-text="'<'"
              :next-text="'>'"
              :container-class="'pagination'"
              :page-class="'pagination__item'"
              :page-link-class="'pagination__link'"
              :prev-class="'pagination__item pagination__item--prev'"
              :next-class="'pagination__item pagination__item--next'"
              :next-link-class="'pagination__link pagination__link--next'"
              :prev-link-class="'pagination__link pagination__link--prev'"
            />
          </div>
          <app-table-records :all="pagination_abnormal_price.count" :count="reservations_abnormal_price.length"
                             :page="pagination_abnormal_price.page" :limit="5"/>
        </app-cells>
      </template>
      <div v-else class="no-results no-results--margin">
        <img src="@/assets/img/schedule-plug-icon.svg" alt="">
        <div class="no-results__title">No Results</div>
        <div class="no-results__text">There’s no bookings yet</div>
      </div>
    </template>
  </div>
</template>

<script>

import {
  getHotelsList,
  getReservationsHotelsExportAbnormalPrice,
  getReservationsHotelsList, getReservationsMeals
} from '@/http'
import AppAccHotel from '@/components/AppAccHotel.vue'
import StarRating from 'vue-star-rating'
import { format } from 'date-fns'
import AppAccMeal from '@/components/AppAccMeal.vue'

export default {
  name: 'HotelsDashboard',
  components: { AppAccMeal, AppAccHotel, StarRating },
  data() {
    return {
      is_loaded: false,
      reservations_abnormal_price: [],
      reservations_missing_voucher: [],
      reservations_missing_invoice: [],
      reservations_meal_missing_invoice: [],
      pagination_abnormal_price: {
        pages: 1,
        page: 1,
        count: 1,
      },
      pagination_missing_voucher: {
        pages: 1,
        page: 1,
        count: 1,
      },
      pagination_missing_invoice: {
        pages: 1,
        page: 1,
        count: 1,
      },
      pagination_missing_supplier: {
        pages: 1,
        page: 1,
        count: 1,
      },
      pagination_missing_email: {
        pages: 1,
        page: 1,
        count: 1,
      },
      pagination_meals_missing_invoice: {
        pages: 1,
        page: 1,
        count: 1,
      },
      table_missing_supplier: {
        items: [],
        columns: ['name', 'star', 'type.name', 'external', 'region', 'area'],
        options: {
          headings: {
            'name': 'Name',
            'star': 'Star',
            'type.name': 'Type',
            'external': 'External',
            'region': 'Region',
            'area': 'Area',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 10,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      table_missing_email: {
        items: [],
        columns: ['name', 'star', 'type.name', 'external', 'region', 'area'],
        options: {
          headings: {
            'name': 'Name',
            'star': 'Star',
            'type.name': 'Type',
            'external': 'External',
            'region': 'Region',
            'area': 'Area',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 10,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      export_abnormal_loading: false,
    }
  },
  created() {
    this.fetchItems()
  },
  methods: {
    onExportAbnormalPrice() {
      this.export_abnormal_loading = true
      getReservationsHotelsExportAbnormalPrice()
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', `Abnormal Price List ${ format(new Date(), 'dd.MM.yyyy HH_mm') }.xlsx`)
          document.body.appendChild(link)
          link.click()
          URL.revokeObjectURL(url)
          this.export_abnormal_loading = false
        })
    },
    fetchItems() {
      Promise.all([
        getHotelsList({
          supplier: false,
          page: this.pagination_missing_supplier.page,
          page_size: 10,
        }),
        getReservationsHotelsList({
          problem: 'missing_invoice',
          page: this.pagination_missing_invoice.page,
          page_size: 5,
        }),
        getReservationsHotelsList({
          problem: 'missing_voucher',
          page: this.pagination_missing_voucher.page,
          page_size: 5,
        }),
        getReservationsHotelsList({
          problem: 'abnormal_price',
          page: this.pagination_abnormal_price.page,
          page_size: 5,
        }),
        getHotelsList({
          reservation_emails: false,
          page: this.pagination_missing_email.page,
          page_size: 5,
        }),
        getReservationsMeals({
          problem: 'invoice',
          page: this.pagination_meals_missing_invoice.page,
          page_size: 5,
        }),
      ])
        .then(res => {
          this.table_missing_supplier.items = res[0].data.results
          this.pagination_missing_supplier.pages = res[0].data.pages
          this.pagination_missing_supplier.count = res[0].data.count

          this.reservations_missing_invoice = res[1].data.results
          this.pagination_missing_invoice.pages = res[1].data.pages
          this.pagination_missing_invoice.count = res[1].data.count

          this.reservations_missing_voucher = res[2].data.results
          this.pagination_missing_voucher.pages = res[2].data.pages
          this.pagination_missing_voucher.count = res[2].data.count

          this.reservations_abnormal_price = res[3].data.results
          this.pagination_abnormal_price.pages = res[3].data.pages
          this.pagination_abnormal_price.count = res[3].data.count

          this.table_missing_email.items = res[4].data.results
          this.pagination_missing_email.pages = res[4].data.pages
          this.pagination_missing_email.count = res[4].data.count

          this.reservations_meal_missing_invoice = res[5].data.results
          this.pagination_meals_missing_invoice.pages = res[5].data.pages
          this.pagination_meals_missing_invoice.count = res[5].data.count

          this.is_loaded = true
        })
    },
    fetchMissingSupplierItems() {
      getHotelsList({
        booked_reservations: true,
        supplier_account: false,
        invoice_required: true,
        page: this.pagination_missing_supplier.page,
        page_size: 10,
      })
        .then(res => {
          this.table_missing_supplier.items = res.data.results
          this.pagination_missing_supplier.pages = res.data.pages
          this.pagination_missing_supplier.count = res.data.count
        })
    },
    fetchMissingEmailItems() {
      getHotelsList({
        reservation_emails: false,
        page: this.pagination_missing_email.page,
        page_size: 5,
      })
        .then(res => {
          this.table_missing_email.items = res.data.results
          this.pagination_missing_email.pages = res.data.pages
          this.pagination_missing_email.count = res.data.count
        })
    },
    onClickMissingSupplierPagination(page) {
      this.pagination_missing_supplier.page = page
      this.fetchMissingSupplierItems()
    },
    onClickMissingEmailPagination(page) {
      this.pagination_missing_email.page = page
      this.fetchMissingEmailItems()
    },
    onClickAbnormalPricePagination(page) {
      this.pagination_abnormal_price.page = page
      getReservationsHotelsList({
        problem: 'abnormal_price',
        page: this.pagination_abnormal_price.page,
        page_size: 5,
      })
        .then(res => {
          this.reservations_abnormal_price = res.data.results
          this.pagination_abnormal_price.pages = res.data.pages
          this.pagination_abnormal_price.count = res.data.count
        })
    },
    onClickMissingVoucherPagination(page) {
      this.pagination_missing_voucher.page = page
      getReservationsHotelsList({
        problem: 'missing_voucher',
        page: this.pagination_missing_voucher.page,
        page_size: 5,
      })
        .then(res => {
          this.reservations_missing_voucher = res.data.results
          this.pagination_missing_voucher.pages = res.data.pages
          this.pagination_missing_voucher.count = res.data.count
        })
    },
    onClickMissingInvoicePagination(page) {
      this.pagination_missing_invoice.page = page
      getReservationsHotelsList({
        problem: 'missing_invoice',
        page: this.pagination_missing_invoice.page,
        page_size: 5,
      })
        .then(res => {
          this.reservations_missing_invoice = res.data.results
          this.pagination_missing_invoice.pages = res.data.pages
          this.pagination_missing_invoice.count = res.data.count
        })
    },
    onClickMealsMissingInvoicePagination(page) {
      this.pagination_meals_missing_invoice.page = page
      getReservationsMeals({
        problem: 'invoice',
        page: this.pagination_meals_missing_invoice.page,
        page_size: 5,
      })
        .then(res => {
          this.reservations_meal_missing_invoice = res.data.results
          this.pagination_meals_missing_invoice.pages = res.data.pages
          this.pagination_meals_missing_invoice.count = res.data.count
        })
    },
  }
}
</script>
<style scoped lang="sass">
.hotels-list
  max-width: 1100px
</style>